import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { ApolloClient, InMemoryCache, gql } from '@apollo/client';
import { createUploadLink } from 'apollo-upload-client';

import { LoadFilesTypes } from './actionTypes';
import {
  updateFileSuccess,
  updateFileFail
} from './actions';

import * as url from '../../helpers/url_helper';

function* updateImageClient({ payload }: any): any {
  const getAuthUser = localStorage.getItem('authUser');
  let user;
  if (getAuthUser) {
    user = JSON.parse(getAuthUser);
  }

  try {
    const client = new ApolloClient({
      link: createUploadLink({ uri: url.API_URL }),
      cache: new InMemoryCache(),
    });

    const query = gql`
        mutation LoadFileCSV(
          $file: Upload!
          $ClientId: String
        ) {
          LoadFileCSV(
            file: $file
            ClientId: $ClientId
          ) {
            message
            success
            data {
              PartNumber
              SKUs
              GUIDItem
              Customer
              CustomerGUIDCL
              Inactive
            }
            
          }
        }
      `;

    const mutationPromise = client.mutate({
      mutation: query,
      variables: { file: payload, ClientId: String(user.EMPRESA_ID) },
    });
    const response: Promise<any> = yield call(() => mutationPromise.then((response) => response));
    yield put(updateFileSuccess(response));
  } catch (error) {
    yield put(updateFileFail(error));
  }
}

function* loadFilesSaga() {
  yield takeEvery(LoadFilesTypes.UPDATE_FILE, updateImageClient);
}

export default loadFilesSaga;
